// import { useGetAuthStatus } from "@/queries/auth/useGetAuthStatus";
import { IoPersonCircleOutline } from "react-icons/io5";

const NameCard = () => {
  // const { data: user } = useGetAuthStatus();

  return (
    <div className="flex gap-3 items-center">
      {/* <div className="flex justify-center items-center bg-[#80808050] text-darkBlue font-semibold w-[40px] h-[40px] rounded-full">
        {user?.first_name?.[0]}
        {user?.last_name?.[0]}
      </div> */}
      <IoPersonCircleOutline className="md:text-[50px] text-[60px]"/>

      <div>
        {/* <p className="text-darkGrey font-semibold md:block hidden">Hi,</p> */}
        <p className="text-neutral600 md:text-base text-sm">
          Welcome To Your Turingtower VM Dashboard
        </p>
      </div>
    </div>
  );
};

export default NameCard;
